import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";
import PropTypes from "prop-types";
import { lang } from "../../../i18nLang";

const useButtonStyles = makeStyles((theme) => ({
  error: {
    color: theme.palette.error.main,

    "&:hover": {
      backgroundColor: "rgba(158, 0, 0, 0.04)",
    },
  },
}));

interface IProps extends DialogProps {
  title: string;
  onConfirm?: Function;
  cancelLabel?: string;
  showCancel?: boolean;
  confirmLabel?: string;
  showConfirm?: boolean;
  disabledConfirm?: boolean;
  typeConfirm?: "info" | "error";
  enableBackdropClickClose?: boolean;
  children: any;
}

function DialogModal({
  title,
  open,
  onClose,
  onConfirm,
  cancelLabel,
  showCancel = true,
  confirmLabel,
  showConfirm = true,
  disabledConfirm,
  typeConfirm,
  enableBackdropClickClose,
  children,
  ...props
}: IProps) {
  const classes = useButtonStyles();

  const handleClickClose = (ev, reason) => {
    if (enableBackdropClickClose || reason === "click") {
      if (onClose) onClose(ev, reason);
    }
  };

  const handleClickConfirm = async () => {
    if (onConfirm) {
      const error = await onConfirm();
      if (error) return;
    }
    if (onClose) onClose({ type: "click" }, "backdropClick");
  };

  return (
    <Dialog
      {...props}
      open={open}
      onClose={handleClickClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        {showCancel && (
          <Button
            color="default"
            onClick={(ev) => handleClickClose(ev, "click")}
          >
            {cancelLabel}
          </Button>
        )}
        {showConfirm && (
          <Button
            className={classes[typeConfirm || "info"]}
            color="primary"
            onClick={handleClickConfirm}
            disabled={disabledConfirm}
          >
            {confirmLabel}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}

DialogModal.propTypes = {
  title: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  cancelLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
  disabledConfirm: PropTypes.bool,
  typeConfirm: PropTypes.oneOf(["info", "error"]),
  enableBackdropClickClose: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

DialogModal.defaultProps = {
  cancelLabel: lang("cancel"),
  confirmLabel: "Ok",
  showCancel: true,
  showConfirm: true,
  disabledConfirm: false,
  enableBackdropClickClose: false,
};

export default DialogModal;
